import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListViewinline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", {
			strokeLinejoin: "round",
			d: "M6 3h8"
		}), /* @__PURE__ */ _jsx("path", { d: "M2 3h1M2 8h1M2 13h1M6 8h8M6 13h8" })]
	})
});
export default SvgListViewinline;
